import { render, staticRenderFns } from "./VendorUnitEconomicsSummaryReport.vue?vue&type=template&id=f727aa56&"
import script from "./VendorUnitEconomicsSummaryReport.vue?vue&type=script&lang=js&"
export * from "./VendorUnitEconomicsSummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports